import {
  Category,
  Equipment,
  FiltersType,
  OfferType,
  ReferenceLocation,
  SearchProfile,
} from '@/types';
import { PROPERTY_CATEGORY_TITLES } from '@/constants';

interface FiltersObject {
  priceValue?: [number, number];
  rentPriceValue?: [number, number];
  roomNumberValue?: [number, number];
  areaValue?: [number, number];
  offerTypeValue?: OfferType;
  categoriesValue?: Category[];
  equipmentValue?: Equipment[];
  unitListValue?: string[];
  locations?: ReferenceLocation[];
  admunits?: FiltersType['admunits'];
  mapArea?: FiltersType['mapArea'];
  powerConsumptionClasses?: string[];
  energyClassFactors?: string[];
}

//Temporary solution. Real data is needed
const EquipmentMapping = {
  'oldBuilding.true': 'Altbau',
  'hasBalcony.true': 'Balkon / Loggia',
  'disabledFriendly.true': 'Barrierefrei',
  'firstUsage.true': 'Erstbezug',
  'hasParking.true': 'Garage / Abstellplatz',
  'hasGarden.true': 'Garten',
  'hasCellar.true': 'Keller',
  'hasKitchen.true': 'Küche',
  'hasLift.true': 'Lift',
  'newBuilding.true': 'Neubau',
  'hasTerrace.true': 'Terrasse',
};

export const getFiltersFromProfileSearch = (filters: SearchProfile['filters']) => {
  const filtersObject: FiltersObject = {};

  if (filters.offerType) {
    filtersObject.offerTypeValue = filters.offerType;
  }

  if (filters.priceTo) {
    filtersObject.priceValue = [filters.priceFrom || 0, filters.priceTo];
  }

  if (filters.rentPriceTo) {
    filtersObject.rentPriceValue = [filters.rentPriceFrom || 0, filters.rentPriceTo];
  }

  if (filters.roomNumberTo) {
    filtersObject.roomNumberValue = [filters.roomNumberFrom || 0, filters.roomNumberTo];
  }

  if (filters.spaceTo) {
    filtersObject.areaValue = [filters.spaceFrom || 0, filters.spaceTo];
  }

  if (filters.locations?.length) {
    filtersObject.locations = filters.locations as ReferenceLocation[];
  }

  if (filters.categories) {
    filtersObject.categoriesValue = filters.categories.map((category) => ({
      code: category,
      title: PROPERTY_CATEGORY_TITLES[category] || '',
      count: 28,
    }));
  }

  if (filters.customEquips) {
    filtersObject.equipmentValue = filters.customEquips.map((customEquip) => ({
      code: customEquip,
      title: EquipmentMapping[customEquip as keyof typeof EquipmentMapping] || '',
      count: 0,
    }));
  }

  if (filters.countries || filters.districts || filters.division) {
    const set = new Set<string>();
    if (filters.countries) {
      filters.countries.forEach((c) => set.add(c));
    }
    if (filters.division) {
      filters.division.forEach((d) => {
        set.add(d);
        // ensure parent country is included
        const parts = d.split('.');
        if (parts.length >= 2) set.add(parts[0]);
      });
    }
    if (filters.districts) {
      filters.districts.forEach((d) => {
        set.add(d);
        // ensure parent division and country are included
        const parts = d.split('.');
        if (parts.length >= 3) {
          set.add(`${parts[0]}.${parts[1]}`);
          set.add(parts[0]);
        }
      });
    }

    filtersObject.unitListValue = Array.from(set);
  }

  if (filters.admunitIds?.length) {
    filtersObject.admunits = filters.admunitIds.map((id: string) => ({
      id,
      name: '',
      parent_name: '',
    }));
  }

  if (filters.mapArea) {
    filtersObject.mapArea = filters.mapArea;
  }

  if (filters.powerConsumptionClasses?.length) {
    filtersObject.powerConsumptionClasses = filters.powerConsumptionClasses;
  }

  if (filters.energyClassFactors?.length) {
    filtersObject.energyClassFactors = filters.energyClassFactors;
  }

  return filtersObject;
};
